export enum Icon {
  CALENDAR = 'bds/calendar/24',
  INFO = 'bds/info/24',
  INFO_CIRCLE = 'bds/info-circle/24',
  TRASH = 'bds/trash/24',
  SHOP = 'bds/shopping-cart/24',
  STAR = 'bds/star/24',
}
